import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "detail", "configInput", "trendCard", "configHidden" ]

  connect() {
    this.configInputTargets.forEach((input) => this.syncResetButton(input))
  }

  toggleDetails(event) {
    this.detailTargets.forEach(detail => {
      if (detail.dataset.trendKey === event.currentTarget.dataset.trendKey) {
        if (detail.classList.contains("d-none")) {
          detail.classList.remove("d-none")
          detail.classList.add("d-block")
        } else {
          detail.classList.remove("d-block")
          detail.classList.add("d-none")
        }
      } else {
        detail.classList.remove("d-block")
        detail.classList.add("d-none")
      }
    })
  }

  resetToDefault(event) {
    event.preventDefault()

    const resetButton = event.currentTarget
    const row = resetButton.closest("tr")
    const input = row.querySelector("[data-entity-team-trends-target='configInput']")
    if (!input) return

    input.value = input.dataset.defaultValue || ""
    this.syncResetButton(input)
  }

  updateResetVisibility(event) {
    this.syncResetButton(event.currentTarget)
  }

  syncResetButton(input) {
    const row = input.closest("tr")
    if (!row) return

    const defaultValue = input.dataset.defaultValue ?? ""
    const currentValue = input.value.trim()
    const resetCell = row.querySelector("td:last-child")
    let resetButton = row.querySelector("[data-entity-team-trends-target='resetButton']")

    if (currentValue !== "" && currentValue !== defaultValue) {
      if (!resetButton) {
        resetCell.insertAdjacentHTML("beforeend", this.resetButtonHtml())
      }
    } else if (resetButton) {
      resetButton.remove()
    }
  }

  resetButtonHtml() {
    return `
      <button type="button"
              class="btn btn-clear border-0 color-fanword-blue p-0"
              data-entity-team-trends-target="resetButton"
              data-action="click->entity-team-trends#resetToDefault"
              aria-label="Reset to default">
        <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
      </button>
    `
  }

  attemptSubmit(event) {
    event.preventDefault()

    // Build config JSON once per trend card so we don't accidentally write to stat text fields.
    this.trendCardTargets.forEach((trendCard) => {
      const configHiddenInput = trendCard.querySelector("[data-entity-team-trends-target='configHidden']")
      if (!configHiddenInput) return

      const configData = {}
      const cardInputs = trendCard.querySelectorAll("[data-entity-team-trends-target='configInput']")

      cardInputs.forEach((input) => {
        const statKey = input.dataset.statKey
        const configType = input.dataset.configType
        const value = input.value.trim()
        const defaultValue = input.dataset.defaultValue ?? ""

        if (value !== "" && value !== defaultValue) {
          if (configType === "increment" || configType === "threshold") {
            configData[statKey] = { type: configType, value: value }
          } else if (configType === "specific") {
            const values = value
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item.length > 0)

            if (values.length > 0) {
              configData[statKey] = { type: configType, values: values }
            }
          } else {
            configData[statKey] = value
          }
        }

        input.removeAttribute("name")
      })

      configHiddenInput.value = JSON.stringify(configData)
    })

    this.formTarget.submit()
  }

}
